import React from "react";
import { Survey, surveyHelper, ThemeReport } from '../../../amorg-common';
import { QuestionStats } from '../../../amorg-common';
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { H2 } from "../../../designSystem/typography/Heading";
import { ThemePanel } from "./ThemePanel";
import { SurveySegment } from '../../../amorg-common';
import { IndicatorPanel } from "./IndicatorPanel";
import { ReportSummary } from "./ReportSummary";
import { PageSection } from "../../../designSystem/PageSection";


type SurveyReportPanelProps = {
    survey: Survey,
    siteId:string,
    questionStats: QuestionStats[],
    segmentFilter: SurveySegment[][],
    showComments: boolean,
};
export function SurveyReportPanel (props: SurveyReportPanelProps): JSX.Element
{
    const hasLoaded = props.survey && props.questionStats;
    const hasQuestions = hasLoaded && surveyHelper.getAllSurveyQuestions(props.survey).length > 0;

    const report = new ThemeReport(props.survey, props.questionStats);

    return (
        <>
            {hasLoaded && hasQuestions &&
                <>
                    <Flex flexDirection="column" gap={16}>

                        <PageSection
                            header={<H2>Overblik</H2>}
                            defaultCollapsed={false}>
                            <ReportSummary survey={props.survey} questionReports={props.questionStats} />
                        </PageSection>

                        {props.survey.themes.some(t => t.questions.some(q => q.indicators.length > 0)) &&
                            <PageSection
                                header={<H2>Indikatorer</H2>}
                                defaultCollapsed={false}>
                                <IndicatorPanel
                                    survey={props.survey}
                                    siteId={props.siteId}
                                    themes={report.data}
                                    segmentFilter={props.segmentFilter}
                                    showComments={props.showComments} />
                            </PageSection>
                        }

                        <PageSection
                            header={<H2>Spørgsmål fordelt på Tema</H2>}
                            defaultCollapsed={false}>

                            <ThemePanel
                                survey={props.survey}
                                siteId={props.siteId}
                                themes={report.data}
                                segmentFilter={props.segmentFilter}
                                showComments={props.showComments} />
                        </PageSection>
                    </Flex>
                </>
            }
        </>
    );
}